import * as React from "react";
import { OutletContextProps } from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import { useQueryError } from "../../hooks/http/useQueryError";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsAiAssistantTemplates from "./SectionsSettingsAiAssistantTemplates";
import { useFetchAiAssistantTemplates } from "./useFetchAiAssistantTemplates";

interface Props extends OutletContextProps {
  section: SectionInterface;
}

const SectionsSettingsAiAssistantTemplatesPage: React.FC<Props> = (props) => {
  React.useEffect(() => {
    props.setActiveMenu("template");
  }, []);

  const {
    data: aiAssistantTemplates,
    error,
    isPending,
  } = useFetchAiAssistantTemplates({
    sectionId: props.section.id,
  });
  useQueryError(error);

  return (
    <SectionsSettingsAiAssistantTemplates
      section={props.section}
      aiAssistantTemplates={aiAssistantTemplates ?? []}
      isLoading={isPending}
    />
  );
};

const pageInfo = {
  title: "テンプレート",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsAiAssistantTemplatesPage,
  pageInfo,
);
